<template>
  <div class="d-flex flex-column w-100 mt-6">
    <div
      v-for="(item, index) in list"
      :key="item.title"
      class="nav-item"
    >
      <div
        class="nav-link d-flex cursor-pointer fw-bold"
        :class="{ 'px-5': isToolBarOpen, 'mb-2': index < list.length -1 }"
        :style="`--color: var(--bs-${item.color})`"
        @click="switchView(item.href)"
      >
        <v-icon
          :icon="(item.title === active && !isToolBarOpen) ? item.icon + '-blue-500' : item.icon"
          height="20"
          width="20"
          :class="[ open ? 'me-2' : 'mx-auto' ]"
        />
        <div
          v-if="open"
          class="text-blue-700"
          :class="{ 'underlined-text position-relative': item.title === active, }"
        >
          {{ item.title }}
        </div>
      </div>
      <div
        v-if="item.submenu && isToolBarOpen && isPerksRoute"
        class="mb-2 mt-1"
      >
        <div
          v-for="sub in item.submenu"
          :key="sub.title"
        >
          <div
            class="nav-link text-center cursor-pointer fw-bold text-blue-700 py-1"
            :style="`--color: var(--bs-${sub.color})`"
            @click="switchView(sub.href)"
          >
            {{ sub.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="nav-item mt-6">
      <div class="nav-link text-center">
        <a
          :href="getAppUrl('')"
          class="btn btn-primary"
          custom
        >
          <template v-if="isToolBarOpen">
            Ajouter contrat
          </template>
          <v-icon
            v-else
            icon="plus-white"
            height="20"
            width="20"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MainMenu',
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    open: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      active: 'Dashboard',
    };
  },
  computed: {
    ...mapGetters({
      isToolBarOpen: 'ui/isToolBarOpen',
    }),
    isPerksRoute() {
      return this.$route.path.includes('perks');
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.setActive(route);
      },
    },
  },
  mounted() {
    this.setActive(this.$route);
  },
  methods: {
    ...mapActions({
      openCalendly: 'ui/openCalendly',
    }),
    getAppUrl(url) {
      return `${import.meta.env.VITE_WIDGET_URL}${url}`;
    },
    setActive(route) {
      const find = [...this.list].reverse()
        .find((elem) => route.path.includes(elem.matcher || elem.href));
      this.active = find.title;
    },
    switchView(href) {
      if (this.$route.path === `/client/${href}`) {
        return;
      }
      this.$router.push(`/client/${href}`);
    },
  },
};
</script>
<style scoped>
.underlined-text:after {
  content: '';
  width: 100%;
  border-radius: 20px;
  height: 5px;
  position: absolute;
  bottom: -5px;
  right: 0;
  background-color: var(--color);
}
</style>
